import React from 'react';
import { connect } from 'react-redux';
import LayoutWrapper from '../Layout';


const AdminLayoutWrapper = ({ children, user }) => {

  const isAdmin = user.admin;

  const generateSidebar = () => {
    const publicSidebar = [
      {
        route: '/admin',
        title: 'Home',
        key: '/admin'
      },
      {
        route: '/admin/services',
        title: 'Manage Services',
        key: '/admin/services'
      },
    ];

    const privateSidebar = [
      {
        route: '/admin/teams/me',
        title: 'Manage Teams',
        key: '/admin/teams/me'
      }
    ];

    let sidebar = [...publicSidebar];
    sidebar = [...sidebar, ...privateSidebar];
    return sidebar
  }


  return (
    <LayoutWrapper sidebar={generateSidebar()} defaultSelectedKeys="/admin">
      {children}
    </LayoutWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    user: (state && state.app && state.app.user) || {}
  }
}

export default connect(mapStateToProps)(AdminLayoutWrapper);